import $ from 'jquery'
import {KEY_CODE_ESC, KEY_CODE_TAB} from '../keyCodes'
import {cancelBubble} from '../atBrowserUtils'

/**
 * @deprecated try to use DropdownTemplateView
 * @constructor
 */
function DropdownList(){}

DropdownList.prototype.init = function(dropdownListId, className, rowTemplate, rowsData, placeholderForContainer, callbackHandler)
{
    this.isShown = false;
    this.dropdownListId = dropdownListId;
    this.className = className;
    this.rowTemplate = _.template(rowTemplate);
    this.rowsData = rowsData;
    this.placeholderForContainer = placeholderForContainer || "body";
    this.callbackHandler = callbackHandler || {};

    $(document).off("mousedown.dropdownList").on("mousedown.dropdownList", $.proxy(this._mouseDownHandler, this));
    $(window).off("resize.dropdownList").on("resize.dropdownList", $.proxy(this._resizeHandler, this));
    $("body").off("keydown.dropdownList").on("keydown.dropdownList", $.proxy(this._keyDownHandler, this));

    return this;
};

DropdownList.prototype._getContainer = function()
{
    var container = $("#" + this.dropdownListId);
    if (container.length === 0)
    {
        container = $("<div id='" + this.dropdownListId + "' class='" + this.className + "'></div>");
        $(this.placeholderForContainer).append(container);
    }
    else
    {
        container = $(container[0]);
    }
    return container;
};

DropdownList.prototype.updateData = function(data)
{
    this.rowsData = data;
};

DropdownList.prototype.setCallbackHandler = function(callbackHandler)
{
    this.callbackHandler = callbackHandler || {};
};

DropdownList.prototype.showAt = function($element, positionParams)
{
    if (this.preventNextShowing)
    {
        this.preventNextShowing = false;
        return;
    }

    this._renderContent();
    var $container = this._getContainer();

    $container.show();
    this.$elementShowAt = $element;

    positionParams = positionParams || {};
    positionParams.of = this.$elementShowAt;
    showElementAt($container, positionParams);

    ScrollUtils.refreshCustomScroll(this.listScroll);
    this.isShown = true;

    if (this.callbackHandler.onShow)
    {
        this.callbackHandler.onShow();
    }
};

DropdownList.prototype._renderContent = function()
{
    var self = this;
    var $container = this._getContainer();
    $container.empty();
    var $listWrapper = $("<div class='listWrapper'></div>");
    var $listContainer = $("<table class='listContainer'></table>");

    _.each(this.rowsData, function(rowData)
    {
        var $row = $(self.rowTemplate(rowData));
        self._addEventHandlersToRow($row, rowData);
        $listContainer.append($row);
    });

    $listWrapper.append($listContainer);
    $container.append($listWrapper);
    this.listScroll = ScrollUtils.addVerticalScroll($listWrapper, {isFaded: false});
};

DropdownList.prototype._addEventHandlersToRow = function($row, rowData)
{
    var self = this;
    $row.click(function()
               {
                   if (self.callbackHandler.onRowClick)
                   {
                       self.callbackHandler.onRowClick(rowData);
                   }
                   self.hide();
               });
};

DropdownList.prototype.hide = function()
{
    if (this.isShown)
    {
        this.isShown = false;
        this._getContainer().hide();
        if (this.callbackHandler.onHide)
        {
            this.callbackHandler.onHide();
        }
    }
};

DropdownList.prototype._mouseDownHandler = function(event)
{
    if (this.isShown)
    {
        var target = event.target;
        while (target)
        {
            if (target == this.$elementShowAt[0])
            {
                this.preventNextShowing = true;
            }
            if (target.id == this._getContainer()[0].id)
            {
                cancelBubble(event);
                return false;
            }
            target = target.parentElement;
        }
        cancelBubble(event);
        this.hide();
        event.preventDefault();
    }
};

DropdownList.prototype._resizeHandler = function()
{
    this.hide();
};

DropdownList.prototype._keyDownHandler = function(event)
{
    if (this.isShown)
    {
        switch (event.keyCode)
        {
            case KEY_CODE_ESC:
            case KEY_CODE_TAB:
                this.hide();
                break;
        }
        cancelBubble(event.originalEvent);
        return false;
    }
};

export default DropdownList



// WEBPACK FOOTER //
// ./web/js/controls/DropdownList.js